import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ContractBalanceService } from '@cemex-core/cmx-api';
import {
  AdtContractActionTypes,
  FetchBalanceContracts,
  LoadContractBalancesAction,
} from '../actions/contracts.actions';

/**
 * Effects for adt contracts
 */
@Injectable()
export class AdtContractsEffects {
  /**
   * Fetch balance of all contracts available of the product
   */

  adtLoadContractBalance: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(AdtContractActionTypes.FETCH_CONTRACT_BALANCES),
      switchMap((action: FetchBalanceContracts) => {
        this.productCode = action.payload.productCode;
        const contracts = action.payload.contracts;
        const requests = contracts.map((contract) => {
          return this.contractBalanceService
            .getRmsContractsBalance({
              productCode: this.productCode,
              agreementCode: contract.contractCode,
            })
            .pipe(
              catchError(() => {
                return of([]);
              }),
            );
        });
        return forkJoin(requests);
      }),
      map((contracBalances) => {
        const newContractBalances = contracBalances
          .filter((balance) => balance && balance.length)
          .map((balance) => balance[0]);
        return new LoadContractBalancesAction({ [this.productCode]: newContractBalances });
      }),
    ),
  );

  private productCode: string;

  constructor(
    private actions$: Actions,
    private contractBalanceService: ContractBalanceService,
  ) {}
}
